export const toQueryString = (params = {}) => {
    const pairs = [];
    Object.entries(params).forEach(([key, rawValue]) => {
        if (rawValue === null || rawValue === undefined || rawValue === "") {
            return;
        }
        const values = Array.isArray(rawValue) ? rawValue : [rawValue];
        values.forEach((value) => {
            pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        });
    });
    return pairs.join("&");
};

export const withQueryParams = (url, params) => {
    const query = toQueryString(params);
    return query ? `${url}?${query}` : url;
};

export const safelyDecodeURIComponent = (value) => {
    if (typeof value !== "string") {
        return value;
    }
    try {
        return decodeURIComponent(value);
    } catch (_error) {
        return value;
    }
};

export const normalizeSearchValue = (value, isEncoded = false) =>
    isEncoded ? safelyDecodeURIComponent(value) : value;
